import { useCreate } from '@refinedev/core';

type GenerateMeetingAgendaPayload = {
  templateId?: string;
};

export function useGenerateMeetingAgenda() {
  const { mutateAsync, error, isLoading, reset } = useCreate<GenerateMeetingAgendaPayload>();

  const generateMeetingAgenda = async (clientId: string, values: GenerateMeetingAgendaPayload) => {
    return mutateAsync({
      resource: `clients/${clientId}/meeting-agendas`,
      values,
    });
  };

  return {
    generateMeetingAgenda,
    error,
    isLoading,
    reset,
  };
}
